import { createContext } from 'react';

import type { JournalType } from '@/pages/safe/safeJournalApi';

/**
 * 「미작성 · 미실시」 를 누른 화면이 그 자리에서 작성 창을 띄우는 손잡이(사용자 지시 2026-10-27 「작성창이 뜨는 건 좋은데
 * 대시보드에서 화면이 전환되는 건 아닌 것 같아」). 이것을 깐 화면에서는 FixLink 가 주소를 옮기지 않고 이것을 부른다.
 * 깔지 않은 화면에서는 예전처럼 그 현장의 새 일지 주소로 간다.
 */
export const WriteHereContext = createContext<((siteId: string, type: JournalType) => void) | null>(null);
